import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    bottom: ({ onMobile }) => (onMobile ? 'calc(24px + 64.5px)' : '24px'),

    '& div[class*="filledSuccess"]': {
      backgroundColor: '#D8FFE3',
      color: '#0E9C5E'
    },

    '& div[class*="filledError"]': {
      backgroundColor: '#FFDDDD',
      color: '#E45252'
    }
  },

  alert: {
    padding: '6px 50px',
    borderRadius: 8,
    fontSize: theme.size.base,
    boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.1)'
  }
}))

export default useStyles
